/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FbLogoLarge(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FbLogoLarge',
      'aria-hidden': true,
      focusable: false,
      width:  36 * scale,
      height: 36 * scale,
      viewBox: '0 0 36 36',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M34.01 0H1.99C.89 0 0 .89 0 1.99v32.02C0 35.11.89 36 1.99 36h17.24V22.105h-4.706V16.63h4.68v-4c0-4.655 2.836-7.188 6.986-7.188q2.116.007 4.22.24v4.857h-2.87c-2.254 0-2.69 1.066-2.69 2.64v3.473h5.4l-.7 5.45h-4.7V36h9.16A1.99 1.99 0 0 0 36 34.01V1.99C36 .89 35.11 0 34.01 0","fill":"currentColor"}))
}
